export default __webpack_public_path__ + "static/careers-slide-3-78c316a8db60a365177e0fd9a79dea33.png";